export default __webpack_public_path__ + "static/media/D8R.01bb5e9a.pdf";